/* 🤖 this file was generated by svg-to-ts */
export const matIconHttp: {
  name: 'http';
  data: string;
} = {
  name: 'http',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"/></svg>`
};
